<template>
  <div style="padding: 20px; min-height: 630px; background-color: rgba(221, 225, 230, 1); border: solid 1px #ccc">
    <!-- Filtros -->
    <v-card>
      <div class="row mb-2 mt-0">
        <div class="col-md-12" v-if="list_access">
          <div class="col-md-12 elevation-0" style="background: white">
            <div class="row pt-5">
              <div class="col-md-2 pt-0">
                <v-autocomplete :value="emitter" :items="emitters" item-text="name" item-value="id" return-object autocomplete="off" label="Empresa" class="pt-0 mt-0" @input="$emit('update:emitter', $event)"></v-autocomplete>
              </div>

              <div class="col-md-2 pt-0">
                <v-combobox v-model="year_selected" :items="years" label="Año" class="pt-0 mt-0"></v-combobox>
              </div>

              <div class="col-md-2 pt-0">
                <v-combobox v-model="cost_center_selected" autocomplete="off" item-text="name" item-value="id" :items="cost_centers" label="Centro de Costo" class="pt-0 mt-0" clearable></v-combobox>
              </div>

              <div class="col-md-2 pt-0">
                <v-combobox v-model="concepto_selected" autocomplete="off" item-text="name" item-value="id" :items="conceptos" label="Concepto" class="pt-0 mt-0" clearable></v-combobox>
              </div>

              <div class="col-md-3 pt-0">
                <v-combobox v-model="months_selected" autocomplete="off" item-text="name" item-value="id" :items="months" label="Meses" class="pt-0 mt-0" multiple small-chips clearable></v-combobox>
              </div>

              <div class="col pt-0" style="display: flex; justify-content: end">
                <v-btn color="info" @click="filter">Buscar</v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-card>

    <!-- Matriz -->
    <v-card class="mt-3">
      <v-card-title>
        <span class="text-uppercase">{{ page_title }}</span>
        <v-spacer></v-spacer>
        <v-btn color="blue-grey" small dark :loading="dialog_export" :disabled="loading || !data" @click="exportFile"> Exportar <font-awesome-icon class="ml-2" icon="download" /></v-btn>
      </v-card-title>

      <v-alert v-if="filtrado" dense text type="info" class="mx-4 mb-0">
        Con filtro de centro de costo o concepto no se muestra el bloque de Disponibilidades: los filtros acotan los conceptos y dejaría de espejar el movimiento de fondos.
      </v-alert>

      <v-progress-linear v-if="cargando" indeterminate color="info"></v-progress-linear>

      <TablaResultados :data="data" :loading="cargando" by_blocks empty_text="Seleccioná un año y presioná Buscar." @cell-click="onCellClick"></TablaResultados>
    </v-card>

    <ModalTable
      :title="detalle_title"
      :open="open_detalle"
      :cancel="closeDetalle"
      :items="detalle_items"
      :headers="detalle_headers"
      :max_width="1100"
      :loading="loading_detalle"
      @cell-click="onDetalleCellClick"
    />

    <ModalTesoreriaMovement
      modal_title="Movimiento de Tesorería"
      :formBtn="movimiento_formBtn"
      :dialog="dialog_movimiento"
      :item="movimiento_item"
      :service="tesoreriaMovementService"
      @updateDialog="updateDialogMovimiento"
      @loadList="onMovimientoGuardado"
    />

    <DialogReasignarConcepto
      :open="dialog_reasignar"
      :item="reasignar_item"
      :conceptos="conceptos"
      :cost_centers="cost_centers"
      @cancel="closeReasignar"
      @reasignado="onReasignado"
    />
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";

import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import TablaResultados from "./TablaResultados.vue";
import ModalTable from "@/components/ModalTable.vue";
import ModalTesoreriaMovement from "@/views/Treasury/TesoreriaMovements/Modal.vue";
import DialogReasignarConcepto from "@/components/DialogReasignarConcepto.vue";
import ResultadosDetalleMixin from "./ResultadosDetalleMixin.vue";

export default {
  components: { TablaResultados, ModalTable, ModalTesoreriaMovement, DialogReasignarConcepto },
  mixins: [GenericMixin, RolMixin, ExportMixin, ResultadosDetalleMixin],
  props: { emitter: Object, emitters: Array, emitters_loaded: Boolean },
  data() {
    return {
      page_title: "Resultados por Mes",
      data: null,
      years: [],
      year_selected: new Date().getFullYear(),
      cost_center_selected: null,
      concepto_selected: null,
      cost_centers: [],
      conceptos: [],
      months: [
        { id: 1, name: "Enero" },
        { id: 2, name: "Febrero" },
        { id: 3, name: "Marzo" },
        { id: 4, name: "Abril" },
        { id: 5, name: "Mayo" },
        { id: 6, name: "Junio" },
        { id: 7, name: "Julio" },
        { id: 8, name: "Agosto" },
        { id: 9, name: "Septiembre" },
        { id: 10, name: "Octubre" },
        { id: 11, name: "Noviembre" },
        { id: 12, name: "Diciembre" },
      ],
      months_selected: [],
    };
  },
  watch: {
    emitter() {
      if (this.emitter && this.emitter.id) this.filter();
    },
  },
  computed: {
    cargando() {
      return this.loading || !this.emitters_loaded;
    },
    filtrado() {
      return this.cost_center_selected != null || this.concepto_selected != null;
    },
  },
  mounted() {
    this.getYears();
    this.loadCombos();
    this.filter();
  },
  methods: {
    getYears() {
      const year_current = new Date().getFullYear();
      for (var i = 2020; i <= year_current; i++) {
        this.years.push(i);
      }
    },
    loadCombos() {
      generalService.filter({}, Constant.SECTION_COSTS_CENTERS).then((response) => {
        this.cost_centers = response.result;
      });
      generalService.filter({ enabled: "all" }, Constant.SECTION_CONCEPTOS).then((response) => {
        this.conceptos = response.result;
      });
    },
    getFilterParams() {
      return {
        group_by: "month",
        year: this.year_selected,
        cost_center: this.cost_center_selected != null ? this.cost_center_selected.id : null,
        concepto: this.concepto_selected != null ? this.concepto_selected.id : null,
        emitter: this.emitter ? this.emitter.id : null,
        months: this.months_selected.map((month) => month.id),
      };
    },
    // La columna es el mes: el detalle de la cuenta se acota al mes completo del ejercicio.
    getRangoCuenta(cell) {
      const mes = parseInt(cell.columna_id);
      const desde = new Date(this.year_selected, mes - 1, 1);
      const hasta = new Date(this.year_selected, mes, 0);
      return [this.toISODate(desde), this.toISODate(hasta)];
    },
    // Fecha local en Y-m-d: toISOString() la pasa a UTC y en AR adelanta un dia.
    toISODate(date) {
      const mes = ("0" + (date.getMonth() + 1)).slice(-2);
      const dia = ("0" + date.getDate()).slice(-2);
      return date.getFullYear() + "-" + mes + "-" + dia;
    },
    filter() {
      // Sin empresa no se consulta: mezclaría todas.
      if (!this.emitter || !this.emitter.id) return;
      this.loading = true;
      const emitterId = this.emitter ? this.emitter.id : null;
      generalService
        .query(this.getFilterParams(), Constant.SECTION_REPORT_RESULTADOS)
        .then((response) => {
          // Si cambió la empresa mientras llegaba la respuesta, esta ya no corresponde.
          if (emitterId !== (this.emitter ? this.emitter.id : null)) return;
          if (!response.status) {
            this.$toast.error(response.msg, "Error");
            return;
          }
          this.data = response.result;
        })
        .catch((e) => console.log(e))
        .finally(() => (this.loading = false));
    },
    exportFile() {
      const param = this.getFilterParams();
      param.export = true;
      this.exportExcel(Constant.SECTION_REPORT_RESULTADOS, param, "Resultados-Tesoreria-Mensual-" + this.year_selected + ".xlsx");
    },
  },
};
</script>
